globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.LimitlessPlugins = appCustomerSpace.LimitlessPlugins || {};

appCustomerSpace.LimitlessPlugins.Tooltip = (function(){

  Tooltip.selector = '[data-popup="tooltip"]';

  Tooltip.init = function($html) {
    $html.find(Tooltip.selector).each(function() {
      new Tooltip($(this));
    })
  }

  function Tooltip($html) {
    this.$html    = $html;
    this.disabled = this.$html.hasClass("no-tooltip");
    this.init();
  }

  Tooltip.prototype = {
    init: function(){
      var tooltip = this;
      tooltip.$html.tooltip({});

      if(tooltip.disabled) {
        tooltip.$html.tooltip("disable");
      } else {
        tooltip.$html.tooltip("enable");
      }

      if(tooltip.$html.attr('href') == undefined && tooltip.$html.data('modal-url') == undefined) { tooltip.displayOnMobile(); }
    },
    displayOnMobile: function() {
      var tooltip = this;
      tooltip.$html.on('touchend', function(e) {
        var $title = $(this).find(".title-info");
        if (!$title.length) {
            $(this).append('<p class="title-info">' + $(this).data("original-title") + '</p>');
            if($(this).data("placement") == "left"){
              $(this).find(".title-info").css('right', ($(this).outerWidth()) + 'px');
              $(this).find(".title-info").css('bottom', '0px');
            }
            if($(this).data("placement") == "top"){
              $(this).find(".title-info").css('right', -($(this).closest('.panel').outerWidth() / 4) + 'px')
            }
        } else {
            $title.remove();
        }
      })
    }
  }

  return Tooltip;

})();
